import React, { Component } from "react";

import { reactLocalStorage } from "reactjs-localstorage";
// import { NaverMap } from "react-naver-maps";
import {
  Form,
  Modal,
  Input,
  Button,

} from "antd";
import { httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import { showAlert } from "../common/AlertModal";


const FormItem = Form.Item;
const ParentUserRegistry = Form.create()(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        name:"",
        price:"",
        pv:"",
        


      
      };
      
    }

  


    onRegistry = (e) => {
      const { form } = this.props;
      e.preventDefault();
      form.validateFields((err, values) => {
        let createData = {
          ...values,
          userIdx: this.props.userIdx
        };
      
        if (!err) {
          if (global.confirm("생성하시겠습니까?"))
            httpPost(httpUrl.createParent, [this.props.userIdx, values.recommendCode], createData)
              .then((res) => {
                if (res.data) {
                  this.props.onOk(values.recommendCode);
                  form.resetFields();
                  showAlert("create");
                } else {
                  
                    alert("후원인의 구매이력이 없거나 최대 레그를 초과하였습니다.");
                    // alert("후원인의 구매 PV 총합이 10만 미만이거나 최대 레그를 초과하였습니다.");
                  
                }
              })
              .catch((error) => {
                alert("알수없는 오류로 실패하였습니다.");

              });
        }
      });
    };

    onCancel = () => {
      this.props.form.resetFields();
      this.props.onCancel();
      
    };

    componentDidMount() {}

    render() {
      const {
      
      } = this.state;
      const { visible, form, defaultValue, color } = this.props;
      const { getFieldDecorator } = form;
      
      const formItemLayout = {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 7 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 }
        }
      };

      

      return (
        <Modal
          visible={visible}
          title="후원인등록"
          okText="등록"
          cancelText="취소"
          onOk={this.onRegistry}
          onCancel={this.onCancel}
          style={{ minWidth: "400px" }}>
         
         <Form {...formItemLayout} onSubmit={this.onRegistry} >
        
        <FormItem label={<span>후원인코드&nbsp;</span>}>
          {getFieldDecorator("recommendCode", {
            rules: [
              {
                required: true,
                message: "후원인을 입력해주세요!",
                
              },
            ]
            
          })(<Input placeholder="후원인을 입력하세요" />)}
        </FormItem>             
        
            
             
          </Form>
        </Modal>
      );
    }
  }
);

export default ParentUserRegistry;


